import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'aieditlab',
    title: 'AI Edit Lab',
    description: 'AiEditLab is an AI-powered video editing platform for creating dynamic animations, text-to-video content, and automated workflows. Perfect for businesses, brands, and creators.',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'React',
            'TypeScript',
            'Material-UI',
            'Node.js',
            'Next.js',
            'Docker',
            'PostgreSQL',
        ],
        url: 'https://aieditlab.unrealos.com',
    },
};

export default data;
